/* @license react-google-recaptcha-ultimate v1.2.2 */
var c="https://www.gstatic.com/recaptcha/releases",e=function(e){window.___grecaptcha_cfg=void 0;var r=document.querySelector("#".concat(e));r&&r.remove();var t=document.querySelector('script[src^="'.concat(c,'"]'));t&&t.remove()};export{c as GSTATIC_URL,e as removeGoogleReCaptchaScript};
//# sourceMappingURL=removeGoogleReCaptchaScript.js.map
